<template>
  <div class="section-title-card">
    <div class="st-title">{{ title }}</div>
    <div v-if="desc" class="st-desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' }
  }
}
</script>

<style lang="scss" scoped>
.section-title-card {
  background: transparent;
  padding: 0;
}

.st-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.st-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
  line-height: 2;
  margin-bottom: 30px;
}
</style>
